import styled from 'styled-components';

import { fontWeight } from '@savgroup-front-common/primitive/helpers/fontWeight';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

import { fontStyle } from '../../../theme/helpers/fontStyle';

export const $Title = styled.div`
  text-align: center;
  ${fontStyle('base')};
  font-weight: ${fontWeight('bold')};
  margin-bottom: ${spacing('xl')};
`;
